export const PROFILE_START = 'profile/profile-start';
export const PROFILE_SUCCESS = 'profile/profile-success';
export const PROFILE_ERROR = 'profile/profile-error';
export const PROFILE_CLEAR = 'profile/profile-clear'